import { Dialog } from '@datacamp/waffles/dialog';
import { Paragraph } from '@datacamp/waffles/paragraph';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  submitFeedback: (...args: any[]) => any;
};

const ReportModalFailure: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <Dialog.Header>{t('ReportModalFailure.header')}</Dialog.Header>
      <Dialog.Body>
        <Paragraph>{t('ReportModalFailure.text')}</Paragraph>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Button onClick={props.submitFeedback} variant="primary">
          {t('ReportModalFailure.primaryButton')}
        </Dialog.Button>
      </Dialog.Footer>
    </>
  );
};

export default ReportModalFailure;
